/** @jsx jsx */
import { css } from '@emotion/core';
import { colorsPalette } from '../../../../../styles/colors';
import { MediaQueries } from '../../../../../styles/Grid';
import { typography, fontWeights } from '../../../../../styles/typography';

export const card = css({
  borderBottomLeftRadius: 32,
  color: colorsPalette.black,
  cursor: 'pointer',
  display: 'flex',
  flexDirection: 'column',
  maxWidth: 460,
  textAlign: 'left',
  textDecoration: 'none',

  '*': {
    fontFamily: 'effra, sans-serif', // overwrite gm styles
  },
});

export const image = css({
  display: 'block',
  height: 130,
  objectFit: 'cover',
  width: '100%',
});

export const cardInfo = css({
  display: 'flex',
  flexDirection: 'column',
  padding: '16px 16px 24px 16px',

  [MediaQueries.mdAndUp]: {
    padding: 24,
  },
});

export const titleAddress = css({
  marginBottom: 16,
});

export const cardTitle = css(typography.effra16, {
  color: colorsPalette.black,
  fontWeight: fontWeights.medium,
});

export const cardAddress = css(typography.effra14, {
  color: colorsPalette.grey60,
  display: 'none',

  [MediaQueries.mdAndUp]: {
    display: 'block',
  },
});

export const solutionItemName = css(typography.effra16, {
  color: colorsPalette.black,
  display: 'block',
});

export const solutionItemPrice = css(typography.effra16, {
  color: colorsPalette.teal,

  [MediaQueries.mdAndUp]: {
    ...typography.effra16,
  },
});
